var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.297,
    height: 34.387,
    viewBox: "0 0 39.297 34.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff3147;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.776,36.02a1.226,1.226,0,0,0,1.749,0L36.235,20.1C42.787,13.466,38.131,2,28.814,2c-5.6,0-8.163,4.112-9.163,4.88C18.645,6.108,16.094,2,10.487,2,1.2,2-3.513,13.436,3.068,20.1Z",
    transform: "translate(0.001 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart (2).b4f830afbe8830b90b3e1b5ac5defe9d.svg";
export { ForwardRef as ReactComponent };